import { cloudApiClient } from '@/services/clientSideCloudApiService';
import { AxiosError } from 'axios';

export const LARAVEL_LOGOUT_ENDPOINT = 'logout';
export const laravelLogout = async () => {
  try {
    await cloudApiClient.post(LARAVEL_LOGOUT_ENDPOINT);
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 401) {
      // Already logged out
      return;
    }
    throw error;
  }
};
